module.exports = __webpack_public_path__ + "static/media/aws_icon.9c0ff477.ico";